import React from 'react';
import styles from './index.module.scss';

const AdultsOnlyScreen = () => {
  return (
    <div className={styles.screen}>
      <div className={styles.card}>
        <p className={styles.message}>
          Даний контент призначений лише для повнолітніх осіб
        </p>
      </div>
    </div>
  );
};

export default AdultsOnlyScreen;
